enum CivilState {
    "Unknown",
    "Single",
    "Married",
    "Divorced",
    "Widowed"
}

// @Datenumtract(Name{"ContactType", Namespace{"http://portal.medfarsolutions.com")
enum ContactType {
    "Unknown",
    "Personal",
    "Work",
    "Other",
    "Othercontactpoint"
}

enum GenderIdentity {
    "Unknown",
    "Male",
    "Female",
    "TransMale",
    "TransFemale",
    "NonBinary",
    "Genderqueer",
    "Genderfluid",
    "TwoSpirit",
    "Agender",
    "PrefersNotToSay",
    "Other"
}

enum MedicalSex {
    "Unknown",
    "Male",
    "Female",
    "Other"
}

enum PaymentCategory {
    "Unknown",
    "Refund",
    "Subscription",
    "Invoice",
    "Deposit"
}

enum PaymentInterval {
    "Unknown",
    "Once",
    "Monthly",
    "Annually",
    "Custom"
}

enum PaymentStatus {
    "Unpaid",
    "Pending",
    "Paid",
    "ReviewRequired",
    "RefundPending",
    "Refunded",
    "RefundPaid"
}

enum PaymentType {
    "Unknown",
    "PayPal",
    "Google",
    "Apple",
    "BankAccount",
    "Mastercard",
    "Visa",
    "Amex",
    "Discover",
    "DinersClub",
    "Jcb"
}

enum PreferredPronouns {
    "He" = 1,
    "She",
    "They",
    "Other"
}

enum SubscriptionStatus {
    "Unknown",
    "Active",
    "Cancelled",
    "Unpaid",
    "Suspended"
}

enum SubscriptionPaymentType {
    "Unknown",
    "Recurring",
    "Prorate",
    "OneTime"
}

enum TaxType {
    "Unknown",
    "GST",
    "QST",
    "HST",
    "VAT"
}

// @Datenumtract(Name{"TelephoneNumberType", Namespace{"http://portal.medfarsolutions.com")
enum TelephoneNumberType {
    "Unknown",
    "Phone",
    "Mobile",
    "Pager",
    "Fax"
}

enum TransactionStatus {
    "Unknown",
    "Pending",
    "Settled",
    "Declined",
    "RefundPending",
    "Refunded",
    "Voided",
    "ReviewRequired",
    "FailedReview",
    "Expired", "Error",
    "Tentative",
    "New"
}

export { CivilState, ContactType, GenderIdentity, MedicalSex, PaymentCategory, PaymentInterval, PaymentStatus, PaymentType, PreferredPronouns, SubscriptionPaymentType, SubscriptionStatus, TaxType, TelephoneNumberType, TransactionStatus };
